import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { CSVDataService } from '@app/export/CSVDataService';
import { StatisticsService } from '@app/services/Statistics/Statistics.service';
import { MenuItem } from 'primeng/api';


@Component({
  selector: 'app-causes',
  templateUrl: './causes.component.html'
})
export class CausesComponent implements OnInit {
  form;
  
  showSpinner = false;
  result;
  items: MenuItem[];
  rowcount = 0;
  total = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private statisticsService: StatisticsService,
    private datePipe: DatePipe) {
    this.router.events.subscribe(x => {
      if (x instanceof NavigationEnd) {
        this.clear();
      }
    });
  }

  ngOnInit() {
    this.form = this.fb.group({
      lodges: ['', ''],
      camps: ['', ''],
      institutions: ['', ''],
      districts: ['', ''],
      parentInstitutionId: ['', ''],
      selectedFilter: ['', ''],
      selectedYears: [null, null],
      startCause: [null, ''],
      endCause: [null, '']
    });
    this.setItems();
  }

  clear() {
    this.form?.reset();
    this.result = [];
    this.rowcount = 0;
    this.setItems();
  }

  setItems() {
    this.items = [
      {
        label: 'Excel',
        icon: 'fa fa-file-excel',
        command: () => this.exportToCSV()
      }];
  }

  exportToCSV() {
    let firstrow;
    const datum = this.datePipe.transform(new Date(), 'yy-MM-dd');
    const filnamn = 'Orsaker_' + datum;
    let data: any[] = [];
    if (!this.total) {
      firstrow = 'År;Medlemsid;Förnamn;Efternamn;Primärinstitution;Startdatum;Slutdatum;Orsak';
      let idx = 0;
      this.form.get('selectedYears').value.forEach(y => {
        this.result[idx].forEach(r => {
          const row = {
            year: y,
            memberId: r.memberId,
            givenName: r.givenName,
            familyName: r.familyName,
            primaryInstitution: r.institution.shortName + ' ' + r.institution.name,
            startDate: this.datePipe.transform(r.startDate, 'yyyy-MM-dd'),
            endDate: this.datePipe.transform(r.endDate, 'yyyy-MM-dd'),
            cause: r.cause?.description
          };
          data.push(row);
        });
        idx++;
      });
    } else {
      firstrow = "År;Kortnamn;Institutionsnamn;Antal;Orsak";
      let idx = 0;
      this.form.get('selectedYears').value.forEach(y => {
        let rowidx = 0;
        this.result[idx].forEach(r => {
          const row = {
            year: rowidx === 0 ? y : null,
            shortName: r.institution.shortName,
            institutionName: r.institution.name,
            familyName: r.attendanceCount,
            cause: r.cause?.description
          };
          data.push(row);
          rowidx++;
        });
        idx++;
      });
    }
    CSVDataService.exportToCsv(filnamn + '.csv', data, firstrow);
  }
  createReport(evt) {
    this.showSpinner = true;
    this.rowcount = 0;
    this.form.patchValue({ selectedYears: this.form.get('selectedYears').value.sort() });
    if (evt.value.camps !== null || evt.value.lodges !== null) {
      this.total = true;
    }
    this.statisticsService.GetCausesStatisticsReport(evt.value).subscribe((response: any) => {
      if (response) {
        this.result = response;
        let idx = 0;
        for (let r of this.result) {
          this.rowcount = this.rowcount + r.length;
          idx++;
        }
        this.setItems();
        this.showSpinner = false;
      }
    });
  }

  search() {

  }
}
